import React from "react";
import { motion, AnimatePresence } from "framer-motion";

import pizzaNamePlate from "../../assets/games/picnic-game/name-plates/pizza-nameplate.png";
import pastaNamePlate from "../../assets/games/picnic-game/name-plates/pasta-nameplate.png";
import burgerNamePlate from "../../assets/games/picnic-game/name-plates/burger-nameplate.png";
import smoothieNamePlate from "../../assets/games/picnic-game/name-plates/smoothie-nameplate.png";

/* animation imports */
import { elementsEntryExit } from "../../assets/js/animations";

const DishTypeNameWrapper = ({ dishType }) => {
  return (
    <div className="dish-type-name-wrapper">
      <AnimatePresence>
        <motion.div
          layout
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          className={`dish-type-name ${dishType === "pizza" ? "active" : ""}`}
          key="pizza"
        >
          <div className="dish-type-name-img">
            <img src={pizzaNamePlate} alt="" />
          </div>
        </motion.div>
        <motion.div
          layout
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          className={`dish-type-name ${dishType === "pasta" ? "active" : ""}`}
          key="pasta"
        >
          <div className="dish-type-name-img">
            <img src={pastaNamePlate} alt="" />
          </div>
        </motion.div>
        <motion.div
          layout
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          className={`dish-type-name ${dishType === "burger" ? "active" : ""}`}
          key="burger"
        >
          <div className="dish-type-name-img">
            <img src={burgerNamePlate} alt="" />
          </div>
        </motion.div>
        <motion.div
          layout
          variants={elementsEntryExit}
          initial="initial"
          animate="animate"
          exit="exit"
          className={`dish-type-name ${
            dishType === "smoothie" ? "active" : ""
          }`}
          key="smoothie"
        >
          <div className="dish-type-name-img">
            <img src={smoothieNamePlate} alt="" />
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default DishTypeNameWrapper;
